import { InjectionToken } from '@angular/core';

import type { IDxpHubConnectionProvider } from '../services/providers/i-dxp-hub-connection.provider';

export const DXP_HUB_CONNECTION_PROVIDER = new InjectionToken<IDxpHubConnectionProvider>(
  'IDxpHubConnectionProvider',
);
